import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import LayoutListItem from 'components/LayoutListItem';
import { LayoutListItemActions, LayoutListItemOwnProps, LayoutListItemSelectors } from 'components/LayoutListItem/models';
import { addSelectedAssetPanelComponent, removeSelectedAssetPanelComponent, toggleDragState } from 'containers/App/actions';
import { selectedComponentItem } from 'containers/App/selectors';
import { deleteComponent } from 'containers/Documents/actions';
import { showModal } from 'containers/ModalManager/actions';
import { documentIdsAreBeingUploaded } from 'containers/Project/selectors';
import { setAssetIdToScroll } from 'containers/ProjectPanel/actions';
import { assetIdToScroll, selectLayoutCount } from 'containers/ProjectPanel/selectors';

const mapStateToProps = (state, props) => {
  const id = props.document.get('id');

  return createStructuredSelector({
    assetIdToScroll,
    documentIdsAreBeingUploaded,
    layoutCount: selectLayoutCount(id),
    isSelected: selectedComponentItem(id),
  });
};

const mapDispatchToProps = {
  deleteComponent,
  setAssetIdToScroll,
  addSelectedAssetPanelComponent,
  removeSelectedAssetPanelComponent,
  showModal,
  toggleDragState,
};

export default connect<LayoutListItemSelectors, LayoutListItemActions, LayoutListItemOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(LayoutListItem);
